import * as React from 'react';
import { Card } from '../card';
import { Activity, IActivity } from '../activity/index';
import { Category, ICategories } from '../category/index';
import { get } from 'libs/request';
import urlParams from 'libs/query';
import Loading from 'components/common/loading/index';
import { sendEvent } from 'libs/event';
import validPv from 'services/common/valid-pv';
import env from 'libs/env';
import mapUaToAppId from 'services/common/map-ua-to-app-id';
import ack from 'services/common/ack';
import './index.scss';
import { IGoodsCard } from 'types/goods';
import Gotop from './goto-top';
import { API_EC, API_ORIGIN } from 'config/host';

interface IGoodsFeedProps {
    goodsUrl?: string;
    outScrollDomId?: string;
    children?: any;
    area_type?: string;
    init?: boolean;
}

const GoodsFeed = (props: IGoodsFeedProps) => {
    const [goodsList, updateGoods] = React.useState([]);
    const [page, changePage] = React.useState(0);
    const [triggerValidPv, hadValidPv] = React.useState(false);
    const { init } = props;
    React.useEffect(() => {
        validPv()!.then(() => {
            hadValidPv(true);
        });
    }, []);
    React.useEffect(() => {
        init && getGoods();
    }, [init]);

    const ackImpress = (data: { [index: string]: any }, page: number) => {
        const extra: { [index: string]: any } = {};
        if (!env.isInToutiaoProduct) {
            return;
        }
        if (data && data.list && data.list.length && data.recommond_request_id) {
            extra.goodsIds = data.recommond_groupids.join('|');
            extra.req_id = data.recommond_request_id;
            extra.app_id = mapUaToAppId();
            extra.version_id = (window as any).fxgVersionId;
            extra.load_times = page;
            extra.is_recommend = 1;
            ack(extra);
        }
    };
    const getOrderEventData = () => {
        if (props.area_type === '188') {
            return {
                order_id: urlParams.id
            };
        }
        if (props.area_type === '187') {
            return {
                tab_name: sessionStorage.getItem('order_center_tab_name')
            };
        }
        return {};
    };

    const getGoods = () => {
        const appId = mapUaToAppId();
        const content = '';
        const classifyId = 0;
        // eslint-disable-next-line prettier/prettier
        let url = `${props.goodsUrl}cids=${content}&classifyId=${classifyId}&page=${page}&pageSize=10&addActivity=1&app_id=${appId}`;
        if ((window as any).page_type) {
            const areaType = (window as any).page_type;
            const areaId = (window as any).page_id;
            url += `&area_type=${areaType}&area_id=${areaId}`;
        }
        if (urlParams.origin_type) {
            url += `&origin_type=${urlParams.origin_type}`;
        }
        if (urlParams.product_id) {
            url += `&product_id=${urlParams.product_id}`;
        }

        return get(url).then(
            (response) => {
                const res = (response as any).data;
                if (
                    res.data &&
                    Object.prototype.toString.call(res.data.list) === '[object Array]'
                ) {
                    const ids = [];
                    const activityIds: string[] = [];
                    const recommendRequestId = res.data.recommond_request_id;
                    const totalSize = goodsList.length;
                    let list = res.data.list;
                    list.forEach((s: Record<string, any>, i: number) => {
                        s.req_id = recommendRequestId;
                        s.page = page;
                        s.feed_index = totalSize + i + 1;
                        if (s.card_type === 'goods') {
                            ids.push(s.goods_id);
                            sendEvent('show_product', {
                                fxg_req_id: recommendRequestId,
                                product_id: s.product_id,
                                ...(props.area_type ? { area_type: props.area_type } : {}),
                                ...getOrderEventData()
                            });
                        } else if (s.card_type === 'activity') {
                            activityIds.push(s.id);
                        }
                    });
                    updateGoods(goodsList.concat(list));
                    // page += 1;
                    changePage(page + 1);
                    if (triggerValidPv) {
                        ackImpress(res.data, page);
                    }

                    return res.data.list;
                }

                return [];
            },
            () => {
                return [];
            }
        );
    };

    /* eslint-disable prettier/prettier, max-len */
    return (
        <>
            {props.children ? (
                props.children
            ) : (
                <div className="goods-feed__title">
                    <span>推荐</span>
                </div>
            )}
            <div className="goods-feed">
                {goodsList.map((goods: IGoodsCard | IActivity | ICategories, index: number) => {
                    const cardType = goods.card_type;
                    if (cardType === 'goods') {
                        return (
                            <Card
                                goods={goods as IGoodsCard}
                                key={index}
                                eventExtra={{
                                    area_type: props.area_type,
                                    order_id: urlParams.id,
                                    ...getOrderEventData()
                                }}
                            />
                        );
                    } else if (cardType === 'activity') {
                        return <Activity activity={goods as IActivity} key={index} />;
                    } else if (cardType === 'category') {
                        return <Category key={index} categories={goods as ICategories} />;
                    }

                    return null;
                })}
            </div>
            <Loading
                id="recommend-loading"
                loadFunc={getGoods}
                scrollDomId={props.outScrollDomId}
            />
            <Gotop scrollItemId={props.outScrollDomId} />
        </>
    );
};

GoodsFeed.defaultProps = {
    goodsUrl: `${API_ORIGIN}/channel/ajaxGetGoods?`
};

export default GoodsFeed;
